module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_5_10.46e6b3ca.png";